/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Public_Site_Team_EmptyInputs */

const cs_public_site_team_empty = /** @type {(inputs: Public_Site_Team_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tým zatím nemá zveřejněné profily.`)
};

const en_public_site_team_empty = /** @type {(inputs: Public_Site_Team_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The team has no published profiles yet.`)
};

/**
* | output |
* | --- |
* | "The team has no published profiles yet." |
*
* @param {Public_Site_Team_EmptyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const public_site_team_empty = /** @type {((inputs?: Public_Site_Team_EmptyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Public_Site_Team_EmptyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_public_site_team_empty(inputs)
	return cs_public_site_team_empty(inputs)
});